import React from 'react';
import {observer} from 'mobx-react';
import autobind from 'common/decorators/autobind.js';
import {DirectoryStoreContext} from 'core/stores/RootStore.js';
import {Toggle, Dropdown} from '@HealthShareAU/hs-component-library';
import {TOOLTIP_TELEHEALTH_TEXT} from 'core/constants.js';
import {browserCheckForIE11} from 'core/utils.js';

export default
@observer
class DirectoryHeader extends React.Component {
    static contextType = DirectoryStoreContext;
    getHeading() {
        const {
            locality,
            specialty,
            interest,
            state,
            telehealthDirectory,
            rootStore: {
                paramStore: {isReferrals, isProUser, isClient},
            },
        } = this.context;
        let title =
            isReferrals || isProUser
                ? specialty.pluralProfessionalName
                : specialty.pluralName;
        if (isClient) {
            return null;
        }
        if (interest?.name) {
            title += ` with special interest "${interest.name}"`;
        }
        if (telehealthDirectory && state) {
            title += ` in ${state.name}`;
        } else if (locality) {
            title += ` in ${locality?.name} ${locality?.state?.name} ${locality?.postCode}`;
        }
        return title;
    }

    @autobind
    toggleTelehealthDirectory(event) {
        /*
         *   Triggers a redirect to the relevant directory page
         *     - checked: telehealth directory (telehealth-specialty in state)
         *     - unchecked: regular directory  (specialty in locality)
         */
        if (event.key === ' ') {
            // For space bar, prevent jumping to end of page
            event.preventDefault();
        }

        this.context.locationSearchAPI.updateStore({
            isLoading: true,
            results: [],
        });
        this.context.updateStore({
            bannerAdsHaveLoaded: false,
            telehealthDirectory: !this.context.telehealthDirectory,
        });
        window.location.assign(this.context.toggleDirectoryURL);
    }

    @autobind
    filterTelehealthDirectory() {
        this.context.updateStore({
            filterByTelehealth: !this.context.filterByTelehealth,
        });
    }

    renderTelehealthFilter(emphasized) {
        const {
            telehealthDirectory,
            telehealthDirectoryLoading,
            filterByTelehealth,
        } = this.context;

        return (
            <Toggle
                customClass={`filter${emphasized ? ' primary' : ''}`}
                checked={emphasized ? telehealthDirectory : filterByTelehealth}
                hasContainer
                isPriority={emphasized}
                onChange={
                    emphasized
                        ? this.toggleTelehealthDirectory
                        : this.filterTelehealthDirectory
                }
                text="Offers Telehealth"
                tooltip={
                    browserCheckForIE11() ? null : TOOLTIP_TELEHEALTH_TEXT
                }
                type="checkbox"
            />
        );
    }

    renderFilters() {
        const {
            genders,
            languages,
            specialty,
            selectedLanguage,
            selectedGender,
        } = this.context;

        const handleSelectFilter = (
            name,
            filterBy,
            filterOptions,
            filterName,
        ) => {
            const option = filterOptions.find(
                (opt) => opt.name === filterName,
            );
            this.context.updateStore({
                bannerAdsIsLoading: true,
                [filterBy]: option || {
                    code: 'any',
                    name: `Any ${name}`,
                },
            });
        };
        return (
            <>
                {this.renderTelehealthFilter(specialty.offersTelehealth)}
                <Dropdown
                    onChange={(languageOption) => {
                        handleSelectFilter(
                            'Language',
                            'selectedLanguage',
                            languages,
                            languageOption,
                        );
                    }}
                    options={languages}
                    side="left"
                    value={selectedLanguage.name}
                    width={200}
                />
                <Dropdown
                    onChange={(genderOption) => {
                        handleSelectFilter(
                            'Gender',
                            'selectedGender',
                            genders,
                            genderOption,
                        );
                    }}
                    options={genders}
                    side="left"
                    value={selectedGender.name}
                    width={180}
                />
            </>
        );
    }

    render() {
        const {
            rootStore: {
                paramStore: {isClient},
            },
        } = this.context;
        return (
            <header className="directory-header">
                {!isClient && <h1>{this.getHeading()}</h1>}
                <section className="filters">
                    <>{this.renderFilters()}</>
                </section>
            </header>
        );
    }
}
